import { NewsHubWithSearch } from '@dreamstack/feature-components/src/news/NewsHubWithSearch'
import { getStaticNewsProps } from '@dreamstack/feature-components/src/news/NewsHub'
import { NEWS_TYPES_WEB } from '@dreamstack/feature-components/src/news/newsTypeUrls.static'
import { getStaticPropsPlus } from '../../lib/getStaticPropsPlus'

export default function NewsHubPage() {
  return <NewsHubWithSearch showSubhero={false} newsTypes={NEWS_TYPES_WEB} />
}

export const getStaticProps = getStaticPropsPlus({
  getProps: getStaticNewsProps,
})
